export const environment = {
  production: true,
  apiEndpoint: 'https://api.manmathsacademy.com/api/v1/admin/',
};
